// DO NOT STORE ANY SECRETS IN THIS FILE

export interface Config {
  oidc: {
    authority: string;
    clientId: string;
    clientSecret: string;
    redirectUri: string;
    silentRedirectUri: string;
    scope: string;
    responseType: string;
    postLogoutRedirectUri: string;
  };
  endpoints: {
    remarkable: string;
  };
}

const local: Config = {
  oidc: {
    authority: "https://dev-identity.hcssapps.com",
    clientId: "remarkable-standalone",
    clientSecret: "dummy",
    redirectUri: "https://localhost:3000/oidc/signin-callback",
    silentRedirectUri: "https://localhost:3000/oidc/silent-renew",
    scope: "openid profile remarkable:read remarkable:write",
    responseType: "code",
    postLogoutRedirectUri: "https://localhost:3000/oidc/logout",
  },
  endpoints: {
    remarkable: "https://remarkable-dev.hcssapps.com",
  },
};

const dev: Config = {
  oidc: {
    authority: "https://dev-identity.hcssapps.com",
    clientId: "remarkable-standalone",
    clientSecret: "dummy",
    redirectUri: "https://dev-comments.hcssapps.com/oidc/signin-callback",
    silentRedirectUri: "https://dev-comments.hcssapps.com/oidc/silent-renew",
    scope: "openid profile remarkable:read remarkable:write",
    responseType: "code",
    postLogoutRedirectUri: "https://dev-comments.hcssapps.com/oidc/logout",
  },
  endpoints: {
    remarkable: "https://remarkable-dev.hcssapps.com",
  },
};

const staging: Config = {
  oidc: {
    authority: "https://staging-identity.hcssapps.com",
    clientId: "remarkable-standalone",
    clientSecret: "dummy",
    redirectUri: "https://staging-comments.hcssapps.com/oidc/signin-callback",
    silentRedirectUri:
      "https://staging-comments.hcssapps.com/oidc/silent-renew",
    scope: "openid profile remarkable:read remarkable:write",
    responseType: "code",
    postLogoutRedirectUri: "https://staging-comments.hcssapps.com/oidc/logout",
  },
  endpoints: {
    remarkable: "https://remarkable-staging.hcssapps.com",
  },
};

const production: Config = {
  oidc: {
    authority: "https://identity.hcssapps.com",
    clientId: "remarkable-standalone",
    clientSecret: "dummy",
    redirectUri: "https://comments.hcssapps.com/oidc/signin-callback",
    silentRedirectUri: "https://comments.hcssapps.com/oidc/silent-renew",
    scope: "openid profile remarkable:read remarkable:write",
    responseType: "code",
    postLogoutRedirectUri: "https://comments.hcssapps.com/oidc/logout",
  },
  endpoints: {
    remarkable: "https://remarkable.hcssapps.com",
  },
};

const hostname = window.location.hostname.toLowerCase();
export const config = {
  ...production,
  ...(hostname.includes("staging-") ? staging : {}),
  ...(hostname.includes("dev-") ? dev : {}),
  ...(hostname.includes("localhost") ? local : {}),
  // add additional environments as needed
};
